import axios, { AxiosPromise } from 'axios';
import { ISale } from '../../../@types/model/sales/sale';
import { ISaleLineRelatedData } from '../../../@types/model/sales/saleLineRelatedData';
import { ISaleLineView } from '../../../@types/model/sales/saleLineView';
import { ISaleUpsert } from '../../../@types/model/sales/saleUpsert';


export default class SaleHttpService {
    public static getSaleData() : AxiosPromise<Array<ISale>> {
        return axios.get(`${API_URL}/v1/Sale`);
    }

    public static addSale(saleImport : ISaleUpsert) : AxiosPromise<ISale> {
        return axios.post(`${API_URL}/v1/Sale/PostSale`, saleImport);
    }

    public static revertSaleImport(saleId : number) : AxiosPromise<ISale> {
        const sale = {
            saleId,
        };
        return axios.post(`${API_URL}/v1/Sale/RevertSaleImport`, sale);
    }

    public static changeSaleImportFileName(saleId : number, newFileName : string) : AxiosPromise<ISale> {
        const sale = {
            saleId,
            newFileName,
        };
        return axios.post(`${API_URL}/v1/Sale/UpdateSaleFileName`, sale);
    }

    public static getSaleLines(saleId : number) : AxiosPromise<Array<ISaleLineView>> {
        return axios.get(`${API_URL}/v1/SaleLine`, {
            params: {
                saleId,
            },
        });
    }

    public static getSaleLineRelatedData(loadMasterData ?: boolean) : AxiosPromise<ISaleLineRelatedData> {
        return axios.get(`${API_URL}/v1/SaleLine/SaleLineRelatedData`, {
            params: { loadMasterData },
        });
    }
}
